export const nombreSede = (sede) => (typeof sede === 'string' ? sede : sede?.nombre ?? '—');